import { SensorDataSessionFormShape } from "@containers/SensorDataSession/interfaces";
import { FormikErrors, FormikTouched } from "formik";
import React from "react";

import "./index.scss";

interface SensorDataSessionFormProps {
  name: keyof SensorDataSessionFormShape;
  touced: FormikTouched<SensorDataSessionFormShape>;
  errors: FormikErrors<SensorDataSessionFormShape>;
}

const FilesErrorMessage: React.FunctionComponent<SensorDataSessionFormProps> = (props) => {
  return props.touced[props.name] && typeof props.errors[props.name] === "string" ? (
    <div className="files-error-message">{String(props.errors[props.name])}</div>
  ) : null;
};

export default FilesErrorMessage;
